import { Container, Stack, Typography } from '@mui/material';
import { coral, dusk, icyGradient2, midnight } from 'theme/Theme';

import EasySubscribeImg from '../../../assets/easy-subscribe-img-banner.svg';

const EasySubscribeHeroSection = () => {
  return (
    <Container
      maxWidth={false}
      sx={{
        background: icyGradient2,
        pb: { lg: 10, xs: 0 },
        pt: { sm: 10, xs: '27px' },
        px: 2,
      }}
    >
      <Stack
        direction={{ lg: 'row', xs: 'column' }}
        justifyContent='space-between'
        sx={{ alignItems: 'center', maxWidth: 1200, mx: 'auto' }}
      >
        <Stack sx={{ maxWidth: '830px' }}>
          <Typography
            sx={{ color: coral, fontFamily: 'RotaExtraBold', fontSize: '18px', mb: '10px' }}
          >
            Easy Subscribe
          </Typography>
          <Typography
            sx={{
              color: midnight,
              fontFamily: 'RotaExtraBold',
              fontSize: { sm: '50px', xs: '30px' },
              mb: '20px',
              width: { sm: '80%', xs: '100%' },
            }}
          >
            Capture contact details in one click, no wallet sign needed
          </Typography>
          <Typography
            sx={{ color: dusk, fontFamily: 'RotaSemiBold', fontSize: { md: '22px', xs: '20px' } }}
          >
            Dramatically increase user engagement by adding email and <br /> Telegram alerts on your
            marketing site. Quickly add Easy <br /> Subscribe to your site in hours.
          </Typography>
        </Stack>
        <Stack sx={{ pt: { md: 0, xs: '30px' } }}>
          <img alt='notifi-card' src={EasySubscribeImg} />
        </Stack>
      </Stack>
    </Container>
  );
};

export default EasySubscribeHeroSection;
